module.exports = __webpack_public_path__ + "img/img3.0bc4b4ee.png";